module.exports = __webpack_public_path__ + "static/media/9.444d39df.jpg";